export default __webpack_public_path__ + "static/media/timer.dab687ce.svg";